import { Box, Typography, Stack, Button,  Grid } from "@mui/material";
import NavBar from "../components/Navbar";
import FooterSection from "../components/FooterSection";
import { useState } from "react";
import cakes from "../components/cakelist";
import ProductCard from "../components/ProductCard";
import CakeDetailsDialog from "../components/cakeDetailsDialog";
import { useInView } from "../components/hook";

const categories = [
  "All",
  "Chocolate",
  "Classic",
  "Fruit",
  "Caramel",
  "Coffee",
];

export default function MenuPage() {
  const [ref, show] = useInView(0.05);
  const [active, setActive] = useState("All");
  const [selectedCake, setSelectedCake] = useState(null);

  const filteredCakes =
    active === "All" ? cakes : cakes.filter((cake) => cake.category === active);
  return (
    <>
      <NavBar />
      <Box
        ref={ref}
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 2,
          pt: { xs: 10, md: 20 } 
        }}
      >
        
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "37px",
            width: "185px",
            bgcolor: "#f7f4ec",
            borderRadius: "20px",
            boxShadow: "0 0 32px rgba(242,156,36,0.3)",
            animation: "glow 2.5s ease-in-out infinite",

            "@keyframes glow": {
              "0%": {
                boxShadow: "0 0 15px rgba(242, 156, 36, 0.73)",
              },
              "50%": {
                boxShadow: "0 0 22px rgba(242, 182, 99, 0.8)",
              },
              "100%": {
                boxShadow: "0 0 15px rgba(237, 184, 111, 0.77)",
              },
            },
          }}
        >
          <Typography
            sx={{ fontSize: "13px", fontWeight: 600, color: "#e99e26ff" }}
          >
            Explore Our Collections
          </Typography>
        </Box>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ md: 3 }}
          sx={{ mt: 2 }}
        >
          <Typography variant="h2" sx={{textAlign:'center'}}>Our</Typography>
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(90deg, #f19923, #d87213)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 900,
            }}
          >
            Cake Menu
          </Typography>
        </Stack>
        <Typography
          sx={{ color: "#847062", maxWidth: 694, textAlign: "center" }}
        >
          From classic favorites to innovative creations, each cake is
          handcrafted with love and the finest ingredients.
        </Typography>
        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          mb={4}
          flexWrap="wrap"
          useFlexGap
          sx={{ rowGap: 1.5 }}
        >
          {categories.map((cat) => (
            <Button
              key={cat}
              onClick={() => setActive(cat)}
              variant={active === cat ? "contained" : "outlined"}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                background:
                  active === cat
                    ? "linear-gradient(45deg, #f29c24, #d56d12)"
                    : "transparent",
                borderColor: "#b1a5987c",
                color: active === cat ? "#fff" : "#000",
                transition: "all 0.25s ease",

                "&:hover": {
                  background: "linear-gradient(45deg, #f29c24, #d56d12)",
                  color: "#fff",
                  transform: "translateY(-7px)",
                },
              }}
            >
              {cat}
            </Button>
          ))}
        </Stack>
        <Grid
          
          container
          spacing={3}
          sx={{
            px: { xs: 2, md: 8 },
            mt: { xs: 2, md: 4 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          {filteredCakes.map((cake, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={cake.id}>
              <ProductCard
                index={index}
                show={show}
                cake={cake}
                onOpen={setSelectedCake}
              />
            </Grid>
          ))}
        </Grid>

        <CakeDetailsDialog
          cake={selectedCake}
          open={Boolean(selectedCake)}
          onClose={() => setSelectedCake(null)}
        />
      </Box>
      <Box sx={{ height: "40px" }} />
      <FooterSection />
    </>
  );
}
